"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCheckedPropsSDKFactory = void 0;
const validations_1 = require("../validations");
const _checkedPropsSDKFactory = (inputValidator) => api => {
    const { props, setProps } = api;
    return {
        get checked() {
            return props.checked || false;
        },
        set checked(value) {
            setProps({ checked: value || false });
            inputValidator.validate({
                viewerSdkAPI: api,
                showValidityIndication: true,
            });
        },
    };
};
const createCheckedPropsSDKFactory = (inputValidator) => validations_1.withValidation(_checkedPropsSDKFactory(inputValidator), {
    type: ['object'],
    properties: {
        checked: {
            type: ['boolean', 'nil'],
        },
    },
});
exports.createCheckedPropsSDKFactory = createCheckedPropsSDKFactory;
//# sourceMappingURL=checkedPropsSDKFactory.js.map